import { render, staticRenderFns } from "./tagsViews.vue?vue&type=template&id=76b3fd9e&scoped=true&"
import script from "./tagsViews.vue?vue&type=script&lang=js&"
export * from "./tagsViews.vue?vue&type=script&lang=js&"
import style0 from "./tagsViews.vue?vue&type=style&index=0&id=76b3fd9e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./tagsViews.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b3fd9e",
  null
  
)

export default component.exports